import { useSelector } from "react-redux";

import { getTableFilterConditions } from "../../../../../../ducks/table/selectors";
import { useTableSelectionCondition } from "../../../../../../hooks/table/useTableSelectionCondition";
import { useGeometrySelectionConditions } from "../../../../../../hooks/geometrySelection/useGeometrySelectionConditions";
import { useDialogInfo } from "../../../../../../hooks/useDialogs";

import { LayerInfo } from "../../../../../../interfaces/resourceInfo";
import { FilterConditionOperation } from "../../../../../LayerFilter/types";

export const useLayerConditionFromTable = (layer?: LayerInfo): string => {
  const { options } = useDialogInfo();
  const tableSelectionCondition = useTableSelectionCondition(options?.fromTable ? layer : undefined);
  const geometrySelectionConditions = useGeometrySelectionConditions();
  const tableFilterConditions = useSelector(getTableFilterConditions);

  if (!layer) {
    return "";
  }

  return options?.fromTable || options?.fromFeatureCard
    ? [
        layer.configuration.condition,
        tableSelectionCondition,
        geometrySelectionConditions?.[layer.name],
        tableFilterConditions?.[layer.name],
      ]
        .filter(Boolean)
        .join(` ${FilterConditionOperation.AND} `)
    : "";
};
